import { Flex, Typography } from 'antd';
import styled from 'styled-components';

const ParagraphStyled = styled(Typography.Paragraph)`
	&.ant-typography {
		margin-bottom: 0;
	}
`;

type Props = {
	title: string;
	paragraphs: string[];
};

export const Section = ({ title, paragraphs }: Props) => (
	<Flex vertical align="flex-start" style={{ marginBottom: 30 }}>
		<Typography.Title level={4}>{title}</Typography.Title>
		{paragraphs.map(paragraph => (
			<ParagraphStyled key={paragraph}>{paragraph}</ParagraphStyled>
		))}
	</Flex>
);
